import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class ResourcesTeamsRoute extends Route {
  @service('store') store;
  @service router;

  beforeModel() {
    this.router.on('routeDidChange', this.redirectToInnerPage);
    this.router.on('routeWillChange', this.blockInnerToParentPage);
  }

  model() {
    return RSVP.hash({
      teams: {
        active: this.store.query('team', { active: true }),
        archived: this.store.query('team', { active: false }),
      },
    });
  }

  redirectToInnerPage = (transition) => {
    if (transition?.to?.name === 'settings.teams.index')
      this.router.transitionTo('settings.teams.active');
  };

  blockInnerToParentPage = (transition) => {
    if (
      transition?.to?.name === 'settings.teams.index' &&
      ['settings.active', 'settings.archived'].includes(transition?.from?.name)
    )
      transition.abort();
  };

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.router.off('routeDidChange', this.redirectToInnerPage);
      this.router.off('routeWillChange', this.blockInnerToParentPage);
    }
  }
}

export default instrumentRoutePerformance(ResourcesTeamsRoute);
